import React from 'react'
import {faCog, faKey, faTrash} from '@fortawesome/free-solid-svg-icons'
import Tabs from "../Tabs/Tabs";

function RoleNav({roleId}) {
    return (
        <Tabs>
            <div faIcon={faCog} exactTo={"/access/role/" + roleId} label="Properties">
            </div>
            <div faIcon={faKey} exactTo={"/access/role/" + roleId + "/s3keys"} label="S3 Keys">
            </div>
            <div faIcon={faTrash} exactTo={"/access/role/" + roleId + "/delete"} label="Delete">
            </div>
        </Tabs>
    );
}

export default RoleNav
